// extracted by mini-css-extract-plugin
export default {"content":"comment-modal_content__p0qy8"};